export const SET_LANGUAGE = 'set-language';
export const SET_AVAILABLE_LANGUAGES = 'set-available-languages';
export const SET_LANGUAGE_ID = 'set-language-id';
export const SET_CLEAR_LANGUAGES = 'clear-available-language';
